import useDebounce from "app/hooks/useDebounce";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { changeProfileField } from "app/store/transmission/slice/transmissionSlice";
import { cloneDeep } from "lodash";

const usePatientHistoryInformation = () => {
  const { patientHistoryInformation, patientOriginalHistoryInformation } =
    useSelector((state) => state.transmission);

  const [newPatientHistoryInformation, setNewPatientHistoryInformation] =
    useState({
      patientDiagnosis: [],
      strokeHistory: "",
      strokeHistoryStatus: "unknown",
      anticoag: "",
      anticoagStatus: "unknown",
      anticoagUpdatedAt: "",
      anticoagUpdatedBy: "",
      diagnosisHistory: [],
      refusesOAC: false,
    });

  useEffect(() => {
    if (patientHistoryInformation) {
      const patientHistoryInformationCopy = cloneDeep(
        patientHistoryInformation
      );
      const { anticoagStatus, strokeHistoryStatus } =
        patientHistoryInformationCopy;

      setNewPatientHistoryInformation({
        ...patientHistoryInformationCopy,
        anticoagStatus:
          anticoagStatus === undefined ? "unknown" : anticoagStatus,
        strokeHistoryStatus: strokeHistoryStatus || "unknown",
        refusesOAC: patientHistoryInformationCopy?.refusesOAC || false,
      });
    }
  }, [patientHistoryInformation]);

  /**
   * Return anticoag status
   * if "anticoag" key doesn't exist, return "unknown"
   * else set true or false accordingly
   * @param {*} anticoag
   * @returns anticoagStatus
   */
  const getAnticoagStatus = (anticoag) => {
    const anticoagulantStatus = anticoag?.toLowerCase() || "";
    if (anticoagulantStatus === "yes") return "yes";
    if (anticoagulantStatus === "no") return "no";
    return "unknown";
  };

  const dispatch = useDispatch();

  const debounceDispatch = useCallback(
    useDebounce((value, type) => {
      dispatch(
        changeProfileField({
          type: type ?? "patientHistoryInformation",
          value: value,
        })
      );
    }, 500),
    []
  );

  const handleCancel = () => {
    const copy = cloneDeep(patientOriginalHistoryInformation);
    handleInputChange(copy);
  };

  const handleInputChange = async (updatedInformation) => {
    setNewPatientHistoryInformation({
      ...updatedInformation,
    });
    debounceDispatch(updatedInformation);
  };

  return {
    newPatientHistoryInformation,
    patientHistoryInformation,
    dispatch,
    handleCancel,
    handleInputChange,
    getAnticoagStatus,
  };
};

export default usePatientHistoryInformation;
